// //PROD
// const serverUrl = "https://api-solicitudes.kiritek.com"
// const credencialsNetpay = "9ozphlqx"
// const merchantID = "netpaymx_club"
// console.log(process.env.NODE_ENV);
//DEV  
// const serverUrl = "https://api-solicitudes-dev.kiritek.com"
// const credencialsNetpay = "45ssiuz3"
// const merchantID = "netpaymx_retail"

const serverUrl = process.env.VUE_APP_SERVER_URL
const credencialsNetpay = process.env.VUE_APP_CREDENTIALS_NETPAY
const merchantID = process.env.VUE_APP_MERCHANTID
const MERCHANT_NAME = process.env.VUE_APP_MERCHANT_NAME
const PUBLIC_KEY = process.env.VUE_APP_PUBLIC_KEY
const isProd = process.env.NODE_ENV === 'production'
const NETPAY_API_URL = process.env.VUE_APP_NETPAY_API_URL
// LOCAL
// const serverUrl = "http://localhost:8082/trust1_api_war"
// const credencialsNetpay = "45ssiuz3"
// const merchantID = "netpaymx_retail"

export const variables = {
    serverUrl: serverUrl,
    credencialsNetpay: credencialsNetpay,
    merchantID: merchantID,
    isProd: isProd,
    MERCHANT_NAME: MERCHANT_NAME,
    PUBLIC_KEY: PUBLIC_KEY,
    NETPAY_API_URL: NETPAY_API_URL,
}